import React, { Component } from "react";

// SHARED
import Settings from "../../shared/settings";

// AXIOS
import axios from "axios";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";
import "./FileUploader.css";

// DROPZONE
import Dropzone from "react-dropzone";

// ICONS
import MdFileUpload from "react-icons/lib/md/file-upload";
import MdDone from "react-icons/lib/md/done";
import MdError from "react-icons/lib/md/error";
import FaClose from "react-icons/lib/fa/close";

// ANIMATION
import { Animated } from "react-animated-css";

export default class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.images,
      error: false,
      message: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      images: nextProps.images,
    });
  }

  handleDrop = (files) => {
    let images = this.state.images;

    if (images.length >= 10) {
      this.setState({
        images: images,
        error: true,
        message:
          "Número máximo de fotografias excedido, só são permitidas 10 fotografias",
      });
    } else {
      Object.values(files).forEach((value, index) => {
        images.push({
          id: null,
          loading: 1,
          preview: value.preview,
          file: value,
        });
      });

      this.setState(
        {
          images: images,
          error: false,
          message: "",
        },
        () => {
          let images = this.state.images;
          images.forEach((image, index) => {
            if (image.loading === 1) {
              this.uploadImage(index);
            }
          });
        }
      );
    }
  };

  uploadImage = (index) => {
    let images = this.state.images;

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    var data = new FormData();

    data.append("Media[imageFiles][]", images[index].file);
    data.append("media_type", 2);

    const url = Settings.server + "/api/v1/media/upload";
    axios
      .post(url, data, config)
      .then((response) => {
        const data = JSON.parse(response.data);
        images[index].loading = 2;
        images[index].id = data.file.id;

        this.setState(
          {
            images: images,
          },
          () => {
            const images = this.state.images;

            let ids = [];

            images.forEach((image, index) => {
              ids.push(image.id);
            });

            this.props.addImages(ids);
          }
        );
      })
      .catch((error) => {
        images[index].loading = 3;
        this.setState({
          images: images,
        });
      });
  };

  removeImage = (index) => {
    let images = this.state.images;

    images.splice(index, 1);

    this.setState(
      {
        images: images,
      },
      () => {
        const images = this.state.images;

        let ids = [];

        images.forEach((image, index) => {
          ids.push(image.id);
        });

        this.props.addImages(ids);
      }
    );
  };

  handleDropRejected = (images) => {
    let message = "";

    if (images.length > 1) {
      message = "As imagens selecionadas: ";
      Object.values(images).forEach((value, index) => {
        if (images.length === 2) {
          if (index === images.length - 1) {
            message =
              message +
              " e " +
              value.name +
              " excedem o mimite máximo permitido de 2mb";
          } else {
            message = message + value.name;
          }
        } else {
          if (index === images.length - 1) {
            message =
              message +
              " e " +
              value.name +
              " excedem o mimite máximo permitido de 2mb";
          } else {
            message = message + value.name + ", ";
          }
        }
      });
    } else {
      message = "A imagem selecionada excede o limite máximo permitido de 2mb";
    }

    this.setState({
      error: true,
      message: message,
    });
  };

  render() {
    const { title, t } = this.props;

    const { images, error, message } = this.state;

    return (
      <Content>
        {title && <Title>{title}</Title>}

        <Dropzone
          multiple={true}
          accept="image/*"
          onDrop={this.handleDrop}
          onDropRejected={this.handleDropRejected}
          className="dropzone"
          maxSize={2000000}
        >
          <Text>{t("apply_upload_dropzone")}</Text>
        </Dropzone>

        {error && <Error>{message}</Error>}

        <Animated
          animationIn="fadeIn"
          animationOut="fadeOut"
          isVisible={images.length > 0 ? true : false}
        >
          <ImagesPreview>
            {Object.values(images).map((value, index) => {
              return (
                <Image key={index}>
                  <Animated
                    animationIn="fadeIn"
                    animationOut="fadeOut"
                    isVisible={true}
                  >
                    <Background
                      style={{ backgroundImage: "url(" + value.preview + ")" }}
                    >
                      <ContentImage>
                        <Actions>
                          {value.loading === 1 && (
                            <ButtonUpload className="animation">
                              <div>
                                <MdFileUpload />
                              </div>
                            </ButtonUpload>
                          )}
                          {value.loading === 2 && (
                            <Animated
                              animationIn="fadeIn"
                              animationOut="fadeOut"
                              isVisible={value.loading === 2 ? true : false}
                            >
                              <ButtonUpload>
                                <MdDone />
                              </ButtonUpload>
                            </Animated>
                          )}
                          {value.loading === 3 && (
                            <div>
                              <Animated
                                animationIn="fadeIn"
                                animationOut="fadeOut"
                                isVisible={value.loading === 3 ? true : false}
                              >
                                <ButtonErrorUpload>
                                  <MdError />
                                </ButtonErrorUpload>
                              </Animated>
                              <Remove onClick={(id) => this.removeImage(index)}>
                                <FaClose />
                              </Remove>
                            </div>
                          )}
                        </Actions>
                        {value.loading === 2 && (
                          <Remove onClick={(id) => this.removeImage(index)}>
                            <FaClose />
                          </Remove>
                        )}
                      </ContentImage>
                    </Background>
                  </Animated>
                </Image>
              );
            })}
          </ImagesPreview>
        </Animated>
        {images.length > 0 && <Space />}
      </Content>
    );
  }
}

const Content = styled.div``;
const Title = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: 8px;

  span {
    font-weight: 400;
  }
`;
const Text = styled.div`
  font-size: 15px;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
`;
const ImagesPreview = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding: 10px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  border-radius: 3px;
  margin-top: 15px;
`;
const Image = styled.div`
  width: calc(32% - 10px);
  height: 240px;
  margin: 5px;
  cursor: pointer;
  position: relative;

  @media screen and (max-width: 767px) {
    width: calc(33.3% - 10px);
  }
  @media screen and (max-width: 560px) {
    width: calc(50% - 10px);
  }
  @media screen and (max-width: 460px) {
    width: 100%;
  }
`;
const Background = styled.div`
  width: 100%;
  height: 240px;
  background-size: cover;
  background-position: fixed;
  background-position: center;
`;
const ContentImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ButtonUpload = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  text-align: center;
  background-color: #32d079;
  font-size: 20px;
  line-height: 35px;
  color: #fff;
  opacity: 1;
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
`;
const ButtonErrorUpload = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  text-align: center;
  background-color: red;
  font-size: 20px;
  line-height: 35px;
  color: #fff;
  opacity: 1;
  transition: all 0.3s ease;
  overflow: hidden;
`;
const Error = styled.div`
  font-family: "PT Sans";
  font-size: 13px;
  color: red;
  opacity: 0.8;
  margin-top: 5px;
`;
const Remove = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50px;
  background-color: #fff;
  position: absolute;
  top: -5px;
  right: -6px;
  z-index: 50;
  text-align: center;
  line-height: 27px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  color: hsl(0, 0%, 17%);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: ${Colors.primary};
  }
`;

const Space = styled.div`
  width: 100%;
  height: 30px;
`;



// WEBPACK FOOTER //
// ./src/components/FileUploader/FileUploader.js